import { endOfMonth, isAfter } from "date-fns";
import { PaymentInstrument } from "library/api/payments";

export const getIsPaymentInstrumentExpired = (
  instrument: PaymentInstrument,
) => {
  const {
    expiry_date_month: expiryDateMonth,
    expiry_date_year: expiryDateYear,
  } = instrument;

  // subtract 1 from the month as the months start from 0 in JS
  const expiryDate = endOfMonth(
    new Date(Number(`20${expiryDateYear}`), Number(expiryDateMonth) - 1, 1),
  );

  // easier to test as it allows mocking of Date.now instead of the constructor
  return isAfter(new Date(Date.now()), expiryDate);
};
